import axios, { AxiosError, AxiosResponse } from 'axios';
import { useCallback, useState } from 'react';
import { IError } from '../interface/ICommon';

export type AxiosProps = {
    config: { locale: string; apiDomain: string };
    method: 'get' | 'post' | 'put' | 'delete';
    path: string;
    param?: { [key: string]: string | number | boolean };
    postdata?: { [key: string]: string | number | boolean | undefined };
    l10n: { [key: string]: string };
};

export default function useAxios<T>() {
    const [res, setRes] = useState<T>();
    const [error, setError] = useState<{ errStr: string | undefined; msg: string } | null>(null);
    const [loading, setLoading] = useState(false);

    const fetchData = useCallback(async ({ config, method, path, param, postdata, l10n }: AxiosProps) => {
        try {
            setLoading(true);

            const params = {
                ...param,
                locale: config.locale,
            };

            const res: AxiosResponse<T> = await axios({
                method: method,
                withCredentials: window.isLoginFlag === 'true',
                url: `${config.apiDomain}${path}`,
                params: params,
                data: postdata ? postdata : '',
            });

            setRes(res.data);
            return res.data;
        } catch (err) {
            const er = err as AxiosError<IError>;
            apiError(er, l10n);

            let msg = l10n['common.dataerror'];
            const errStr = er.response?.data.result.error.toLocaleLowerCase();

            switch (errStr) {
                case 'duplicated':
                    msg = l10n['noti.toast2'];
                    break;
                case 'exceeded':
                    msg = l10n['noti.toast3'];
                    break;
                case 'game_character':
                    msg = l10n['noti.choosecharacters'];
                    break;
            }
            setError({ errStr, msg });
        } finally {
            setLoading(false);
        }
    }, []);

    return { res, loading, error, fetchData };
}

const apiError = (err: AxiosError<IError>, l10n: { [key: string]: string }) => {
    if (axios.isAxiosError(err) && err.response) {
        if (err.response?.statusText === 'Unauthorized') {
            window.GNBLogin();
            return;
        }
        switch (err.response.data.result.error.toLocaleLowerCase()) {
            case 'unauthorized':
                window.GNBLogin();
                break;

            case 'unauthenticated':
                window.GNBLogin();
                break;
            default:
                console.log(err.response.data.result);
        }
    }
};
